// Docuseal e-sign client
// Docs: https://www.docuseal.com/docs/api
// Self-host: free. Cloud: $19/mo. API key at https://app.docuseal.com/api
// Set DOCUSEAL_API_KEY + DOCUSEAL_TEMPLATE_ID_{CREATOR,INVESTOR,DEALER} env vars.

export interface DocusealField {
  name: string;
  default_value: string;
}

export interface CreateSigningSessionParams {
  contractType: 'creator' | 'co_ownership' | 'investor' | 'dealer' | 'platform_terms';
  signerEmail: string;
  signerName: string;
  fields?: DocusealField[];
}

export interface SigningSession {
  embedUrl: string;
  submissionId: number;
}

export async function createSigningSession(
  params: CreateSigningSessionParams,
): Promise<SigningSession> {
  const res = await fetch('/api/create-signing-session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  if (res.status === 503) {
    // Template or API key not configured — caller should show fallback UI
    throw Object.assign(new Error('Contract template not configured'), { code: 'NOT_CONFIGURED' });
  }

  if (!res.ok) {
    const { error } = await res.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error ?? `HTTP ${res.status}`);
  }

  return res.json();
}
